import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-payment-success-modal',
  templateUrl: './payment-success-modal.component.html',
  styleUrls: ['./payment-success-modal.component.scss']
})
export class PaymentSuccessModalComponent implements OnInit {
  bodyText = '';
  preferredMessage:string = '';
  heading:string = '';
  labelMessage:string = ''
  constructor(
     private readonly router: Router,
     public readonly ref: DynamicDialogRef,
     public readonly config: DynamicDialogConfig,
     private readonly encryptStorage: EncryptionStorageService
    ) 
    { }

  ngOnInit(): void {
    this.preferredMessage = this.config?.data?.preferredSuccessMessage;
    this.heading = this.config?.data?.headingMessage;
    this.labelMessage = this.config?.data?.labelMsg
  }

  continue(): void {
    this.ref.close();
    let navigationFromViewUrl = this.encryptStorage.getItem('navigationFromView');
    if (!navigationFromViewUrl)
      navigationFromViewUrl = '/driver/booking';
      navigationFromViewUrl += '?tab=1';
    this.router.navigateByUrl(navigationFromViewUrl);
  }

}
